import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Box, Text, Button, Anchor, Menu } from 'grommet';
import { Notes, Edit, Download, Trash, Print, Search, More, Copy } from 'grommet-icons';

import { EmptySearches, Placeholder, ErrorsSearches, Pagination } from '../../../../components';
import { Onboarding } from '../onboarding/onboarding';

import { toggleDetailsLayer } from '../../actions/details';
import { generateCsv } from '../../actions/export-csv';
import { generatePrintSearch } from '../../actions/print-search';
import { toggleFormDeleteLayer } from '../../actions/form-delete';
import { openFormSearchLayer, goToNextPage, goToPrevPage } from '../../actions/form-search';
import { toggleFormManagerLayer, copyLayer } from '../../actions/form-manager';

import { formattedDateTime, formattedNumber } from '../../../../utils';
import rulesName from '../../../../constants/rules';

const SearchResultComponent = (props) => {
  const {
    userLogged: { rules, client },

    loadingFormSearch,
    dataRows,
    totalOfRows,
    getListError,

    startDate,
    endDate,
    reference,
    subject,
    participantId,
    page,
    limit,

    generateCsv,
    generatePrintSearch,
    toggleDetailsLayer,
    toggleFormManagerLayer,
    copyLayer,
    toggleFormDeleteLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,

    totalCreated,
  } = props;

  if(loadingFormSearch && !getListError) {
    return (
      <Placeholder
        title='Carregando...'
        message='Aguarde que estamos preparando as coisas :)'
      />
    );
  }

  if(getListError) {
    return <ErrorsSearches
      button={{
        label: 'Abrir filtros',
        action: openFormSearchLayer
      }}
    />;
  }

  if(totalCreated <= 0 && client.trl) {
  //if(totalCreated > 0 && !client.trl) {
    return <Onboarding />;
  }

  if(!dataRows.length) {
    return <EmptySearches
      buttonFilters={{
        label: 'Abrir filtros',
        action: openFormSearchLayer,
      }}

      buttonCreate={
        rules.includes(rulesName.createAppointment) ?
          { label: 'Novo compromisso', action: toggleFormManagerLayer } : null
      }
    />;
  }

  const optionsMenu = (row) => {
    const options = [];

    if(rules.includes(rulesName.editAppointment)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Edit />
            <Text size='small'>Editar</Text>
          </Box>
        ),
        onClick: () => toggleFormManagerLayer(row)
      });
    }

    if(rules.includes(rulesName.createAppointment)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Copy />
            <Text size='small'>Copiar</Text>
          </Box>
        ),
        onClick: () => copyLayer(row)
      });
    }

    if(rules.includes(rulesName.deleteAppointment)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Trash color='status-error' />
            <Text size='small'>Excluir</Text>
          </Box>
        ),
        onClick: () => { toggleFormDeleteLayer(row); }
      });
    }

    return options;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => {
        return (
          <Box
            direction='row'
            justify='center'
            margin={{ horizontal: 'medium', top: '80px' }}
          >
            <Box
              pad='small'
              width='xlarge'
            >
              <Box
                align='center'
                direction='row'
                justify='between'
                margin={{ bottom: 'small' }}
              >
                <Box
                  direction={size === 'small' ? 'column' : 'row'}
                  align={size === 'small' ? 'baseline' : 'center'}
                  gap={size === 'small' ? null : 'small'}
                >
                  <Text size='xlarge'>{formattedNumber(totalOfRows)}</Text>

                  <Text
                    size={size === 'small' ? 'xsmall' : 'medium'}
                    color='dark-6'
                  >
                    compromisso(s)
                  </Text>
                </Box>

                <Box
                  direction='row'
                  align='center'
                  gap={size === 'small' ? 'large' : 'medium'}
                >
                  {rules.includes(rulesName.exportAppointment) &&
                    <Button
                      plain
                      title='Download Excel (.csv)'
                      icon={<Download />}
                      size='small'
                      margin={{ right: 'xsmall' }}
                      onClick={() => {
                        generateCsv({
                          startDate: formattedDateTime(startDate),
                          endDate: formattedDateTime(endDate),
                          reference,
                          subject,
                          participantId,
                          page: 1,
                          limit: totalOfRows,
                        })
                      }}
                    />
                  }

                  {rules.includes(rulesName.printAppointment) &&
                    <Button
                      plain
                      title='Imprimir resultado da pesquisa'
                      icon={<Print />}
                      size='small'
                      margin={{ right: 'xsmall' }}
                      onClick={() => {
                        generatePrintSearch({
                          startDate: formattedDateTime(startDate),
                          endDate: formattedDateTime(endDate),
                          reference,
                          subject,
                          participantId,
                          page: 1,
                          limit: totalOfRows,
                        })
                      }}
                    />
                  }

                  <Button
                    plain
                    title='Filtrar compromissos'
                    icon={<Search />}
                    onClick={() => { openFormSearchLayer() }}
                  />

                  {rules.includes(rulesName.createAppointment) &&
                    <Button
                      primary
                      color='neutral-1'
                      size='small'
                      label='Novo'
                      onClick={() => { toggleFormManagerLayer() }}
                    />
                  }
                </Box>
              </Box>

              <Box
                direction='row'
                pad={{ vertical: 'medium' }}
                border={{ side: 'bottom', color: 'light-5' }}
                gap='small'
              >
                {size !== 'small' && size !== 'medium' && <Box width='small'>
                  <Text color='dark-2'>Ref.</Text>
                </Box>}

                {size !== 'small' && <Box width='large'>
                  <Text color='dark-2'>Assunto</Text>
                </Box>}

                {size !== 'small' && <Box width='medium'>
                  <Text color='dark-2'>Data</Text>
                </Box>}

                {size !== 'small' && <Box width='medium'>
                  <Text color='dark-2'>Horário</Text>
                </Box>}

                <Box width='medium' />
              </Box>

              {dataRows.map(row => {
                const menu = optionsMenu(row);

                return (
                  <Box
                    key={row.id}
                    align='center'
                    direction='row'
                    pad={{ vertical: size === 'small' ? 'small' : 'xsmall' }}
                    border={{ side: 'bottom', color: 'light-5' }}
                    gap='small'
                  >
                    {size !== 'small' && size !== 'medium' && <Box width='small'>
                      <Anchor
                        title='Abrir detalhes'
                        label={`AG-${row.id}`}
                        onClick={() => { toggleDetailsLayer(row) }}
                      />
                    </Box>}

                    <Box width='large'>
                      <Text color='dark-2' size='small'>{row.subject}</Text>

                      {size === 'small' &&
                        <Text color='dark-2' size='small'>
                          {formattedDateTime(row.startDate, 'ddd, DD MMM YYYY')} - {formattedDateTime(row.startDate, 'HH:mm')} até {formattedDateTime(row.endDate, 'HH:mm')}
                        </Text>}
                    </Box>

                    {size !== 'small' && <Box width='medium'>
                      <Text color='dark-2' size='small'>
                        {formattedDateTime(row.startDate, 'ddd, DD MMM YYYY')}
                      </Text>
                    </Box>}

                    {size !== 'small' && <Box width='medium'>
                      <Text color='dark-2' size='small'>
                        {formattedDateTime(row.startDate, 'HH:mm')} até {formattedDateTime(row.endDate, 'HH:mm')}
                      </Text>
                    </Box>}

                    <Box align='end' width='medium'>
                      <Box direction='row'>
                        <Button
                          title='Abrir detalhes'
                          icon={<Notes color='dark-3' size='medium' />}
                          onClick={() => { toggleDetailsLayer(row) }}
                        />

                        {menu.length > 0 && (<Menu
                          dropProps={{ align: { right: 'right', top: 'top' } }}
                          icon={<More />}
                          items={menu}
                        />)}
                      </Box>
                    </Box>
                  </Box>
                )
              })}

              <Pagination
                totalOfRows={totalOfRows}
                nextPage={goToNextPage}
                prevPage={goToPrevPage}
                filters={{
                  startDate: formattedDateTime(startDate),
                  endDate: formattedDateTime(endDate),
                  reference,
                  subject,
                  participantId,
                  page,
                  limit,
                }}
              />
            </Box>
          </Box>
        )
      }}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ authReducer: { authenticated }, appointmentsReducer: { searchResult, formSearch, trialControl } }) => ({
  userLogged: authenticated,

  startDate: formSearch.startDate,
  endDate: formSearch.endDate,
  reference: formSearch.reference,
  subject: formSearch.subject,
  participantId: formSearch.participantId,
  page: formSearch.page,
  limit: formSearch.limit,

  loadingFormSearch: searchResult.loadingFormSearch,
  dataRows: searchResult.dataRows,
  totalOfRows: searchResult.totalOfRows,
  getListError: searchResult.getListError,

  totalCreated: trialControl.total,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    generateCsv,
    generatePrintSearch,
    toggleDetailsLayer,
    toggleFormManagerLayer,
    copyLayer,
    toggleFormDeleteLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  }, dispath)
};

export const SearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResultComponent);
